<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        User Pattern
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WMDS</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">User Pattern</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detail search start -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">Created_at</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-2" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w')">1W</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m')">1M</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_opt_type">Group Name</label>
        </b-col>
        <b-col v-if="group_name" class="col-xl-3 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="group_name"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-if="group_name" class="col-xl-1 col-md-12 align-self-center mb-3">
          <b-form-group>
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('group')">Clear</b-button>
          </b-form-group>
        </b-col>
        <b-col v-else class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-button variant="add" @click="chainGroup = true">Select Group</b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_group">Status</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <select class="form-control" v-model="so.opt['is_del']" @change="refresh">
              <option disabled value="">Please select Enable or disable</option>
              <option value="false">Enable</option>
              <option value="true">Disable</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_type">Type</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <select class="form-control" v-model="so.opt['type']">
              <option disabled value="">Please select type</option>
              <option value="U">URL</option>
              <option value="S">String</option>
              <option value="R">Regex</option>
              <option value="M">MD5</option>
            </select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_level">Level</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <select class="form-control" v-model="so.opt['level']" @change="refresh">
              <option disabled value = "">Please select level</option>
              <option value = 'H'>Danger</option>
              <option value = 'W'>Warning</option>
              <option value = 'C'>Caution</option>
              <option value = 'S'>Suspicion</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_code">Code</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input v-model="so.opt['code']" @keyup.enter="refresh"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_opt_type">Match Type</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center mt-2">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
              <b-form-radio value="and">Match all</b-form-radio>
              <b-form-radio value="or">Match at least one</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3 float-right">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail search end -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col v-if="view_detail !== false" sm="2">
        <span class="badge badge_border_primary mb-2">TOTAL : <span style="padding-left: 0.8rem"></span>{{model.total.toString().padStart(6, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_info mb-2">Enable : <span style="padding-left: 0.7rem"></span>{{model.enable_S.toString().padStart(6, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_warning mb-2">Disable : <span style="padding-left: 0.7rem"></span>{{model.enable_D.toString().padStart(6, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_danger mb-2">Deleted : <span style="padding-left: 0.4rem"></span>{{model.disable.toString().padStart(6, nbsp) | number}}</span>
        <br>
        <b-input-group>
          <div class="mr-auto mb7 mt-2">
            <span class="badge badge-primary">String : {{model.S | number}}</span>
            <span class="badge badge-info">MD5 : {{model.M | number}}</span>
            <span class="badge badge-warning">URL : {{model.U | number}}</span>
            <span class="badge badge-success">Regex : {{model.R | number}}</span>
          </div>
        </b-input-group>
      </b-col>
      
      <b-col :sm="view_detail !== false ? 10 : 12" class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || 'Search'" v-model="so.sk" @change="sv_reset">
              <option value="">Search</option>
              <option value="is_del">Status</option>
              <option value="level">Level</option>
              <option value="type">Type</option>
              <option value="code">Code</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <!-- WMDS level -->
            <!-- <v-select :disabled="so.adv" v-if="so.sk == 'level'" @change="refresh" v-model="so.sv" :readonly="true" :options="codes.WMDS_TYPE_text"></v-select> -->
            <select class="form-control" :disabled="so.adv" v-if="so.sk == 'level'" @change="refresh" v-model="so.sv">
              <option disabled value = "">Please select level</option>
              <option value = 'H'>Danger</option>
              <option value = 'W'>Warning</option>
              <option value = 'C'>Caution</option>
              <option value = 'S'>Suspicion</option>
            </select>

            <!-- WMDS type -->
            <!-- <v-select :disabled="so.adv" v-if="so.sk == 'type'" @change="refresh" v-model="so.sv" :readonly="true" :options="codes.WMDS_TYPE_text"></v-select> -->
            <select class="form-control" :disabled="so.adv" v-if="so.sk == 'type'" @change="refresh" v-model="so.sv">
              <option disabled value="">Please select type</option>
              <option value="U">URL</option>
              <option value="S">String</option>
              <option value="R">Regex</option>
              <option value="M">MD5</option>
            </select>

            <select class="form-control" :disabled="so.adv" v-model="so.sv" v-if="so.sk == 'is_del'" @change="refresh">
              <option disabled value="">Please select Enable or disable</option>
              <option value="false">Enable</option>
              <option value="true">Disable</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <input type="text" class="form-control col-xl-12" name="input" id="input" v-if="so.sk == 'code' || so.sk == ''" :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh()">
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1" @click="refresh()">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mt-2">
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">Hide deleted</b-checkbox>
          </div>
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="sync.enable" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list"
            show-empty empty-text="not found"
            :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" @row-clicked="detail" style="cursor:pointer;">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="group" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.group ? row.item.group.groupname : '-' }}</del>
              <span v-else>{{row.item.group ? row.item.group.groupname : '-' }}</span>
            </template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | date }}</template>
            <template slot="is_alive" slot-scope="row">
              <b-badge v-if="row.item.is_del" :variant="row.item.is_del ? 'danger' : 'success'"> Deleted </b-badge>
              <span v-else>
                <b-badge variant="success" v-if="row.item.is_alive">On</b-badge>
                <b-badge v-else variant="secondary">Off</b-badge>
              </span>
            </template>
            <template slot="level" slot-scope="row">
              <b-badge v-if="row.item.level == 'H'" variant= "danger">{{codes.WMDS_PATTRN_LEVEL[row.item.level]}}</b-badge>
              <b-badge v-else-if="row.item.level == 'W'" variant="warning">{{codes.WMDS_PATTRN_LEVEL[row.item.level]}}</b-badge>
              <b-badge v-else-if="row.item.level == 'N'" variant="info">{{codes.WMDS_PATTRN_LEVEL[row.item.level]}}</b-badge>
              <b-badge v-else variant = "secondary">{{codes.WMDS_PATTRN_LEVEL[row.item.level]}}</b-badge>
            </template>
            <!-- type 은 꼭 있어야 함 -->
            <template slot="type" slot-scope="row">{{codes.WMDS_TYPE[row.item.type]}}</template>
            <template slot="code" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.code | truncate(50) }}</del>
              <span v-else>{{row.item.code | truncate(50) }}</span>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
    <!-- start modal -->
    <b-modal title="Find then Group and Select" size="xl" v-model="chainGroup" @ok="chainGroup = false" ok-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>